import { createContext, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import API from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  // stable refreshUser using useCallback
  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsLoggedIn(false);
      setUser(null);
      return null;
    }

    try {
      const res = await API.get('/user');
      setUser(res.data);
      setIsLoggedIn(true);
      return res.data;
    } catch (err) {
      console.error('refreshUser failed:', err?.response?.data || err.message);
      setIsLoggedIn(false);
      setUser(null);
      return null;
    }
  }, []); // no internal dependencies that change

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsLoggedIn(true);
      refreshUser();
    }
  }, [refreshUser]);

  const login = useCallback((token, userData) => {
  localStorage.setItem('token', token);
  setIsLoggedIn(true);
  setUser(userData || null);
}, []);

 
  const logout = useCallback(() => {
  localStorage.removeItem('token');
  setIsLoggedIn(false);
  setUser(null);
}, []);

  // Memoize the context value so consumers only re-render when relevant pieces change
  const value = useMemo(() => ({
    isLoggedIn,
    user,
    login,
    logout,
    refreshUser,
  }), [isLoggedIn, user, login, logout, refreshUser]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};